/**
 * Habano "H" Monogram — inspired by Cuban cigar bands + luxury hotel crests.
 * Thin brushed-gold lines, soft circular frame, no tech geometry.
 *
 * Sizes via the `size` prop (default 28). The `withLabel` variant renders the
 * wordmark next to the mark in the same brushed-gold gradient.
 */
export function Monogram({ size = 28, className = "" }) {
  return (
    <svg
      viewBox="0 0 100 100"
      width={size}
      height={size}
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <defs>
        <linearGradient id="habano-gold" x1="15" y1="15" x2="85" y2="85" gradientUnits="userSpaceOnUse">
          <stop stopColor="#D6B16B" />
          <stop offset="0.5" stopColor="#C8A063" />
          <stop offset="1" stopColor="#B8924F" />
        </linearGradient>
      </defs>
      {/* Outer ring — cigar band frame */}
      <circle cx="50" cy="50" r="46" stroke="url(#habano-gold)" strokeWidth="1.2" opacity="0.55" />
      <circle cx="50" cy="50" r="42" stroke="url(#habano-gold)" strokeWidth="0.5" opacity="0.35" />
      {/* H glyph — thin serifed verticals + crossbar */}
      <path
        d="M34 28 V72 M66 28 V72 M34 50 H66"
        stroke="url(#habano-gold)"
        strokeWidth="2.6"
        strokeLinecap="square"
      />
      {/* Tiny serif terminals — barely-there cigar band detail */}
      <path
        d="M30 28 H38 M62 28 H70 M30 72 H38 M62 72 H70"
        stroke="url(#habano-gold)"
        strokeWidth="1.2"
        strokeLinecap="square"
        opacity="0.75"
      />
    </svg>
  );
}

export function Wordmark({ className = "", size = "lg" }) {
  const sizes = {
    sm: { mono: 22, text: "text-base" },
    md: { mono: 28, text: "text-lg" },
    lg: { mono: 34, text: "text-xl" },
    xl: { mono: 44, text: "text-2xl" },
  };
  const s = sizes[size] || sizes.lg;
  return (
    <div className={`inline-flex items-center gap-3 ${className}`}>
      <Monogram size={s.mono} />
      <div className="leading-none">
        <span
          className={`font-display tracking-[0.32em] uppercase ${s.text}`}
          style={{
            background: "linear-gradient(135deg, #D6B16B 0%, #C8A063 50%, #B8924F 100%)",
            WebkitBackgroundClip: "text",
            backgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          Habano
        </span>
      </div>
    </div>
  );
}
